"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UsesToday;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _partial = _interopRequireDefault(require("react-utils/partial"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _omit = _interopRequireDefault(require("../../utils/underscore/omit"));

var _utils = require("../../decorators/utils");

var SimpleDate = _interopRequireWildcard(require("../../core/SimpleDate"));

var _this = void 0;

var instancesForTz = {};
var todayForTz = {};
var intervalHandleForTz = {};

var updateToday = function updateToday(tz) {
  var oldToday = todayForTz[tz];
  var newToday = SimpleDate.now(tz);

  if (!oldToday || !SimpleDate.equals(oldToday, newToday)) {
    todayForTz[tz] = newToday;
    instancesForTz[tz].forEach(function (instance) {
      return instance.forceUpdate();
    });
  }
};

var registerInstance = function registerInstance(instance, tz) {
  if (!instancesForTz[tz]) instancesForTz[tz] = [];
  var instances = instancesForTz[tz];

  if (instances.length === 0) {
    updateToday(tz);
    intervalHandleForTz[tz] = setInterval((0, _partial.default)(updateToday, tz), 60e3);
  }

  instances.push(instance);
};

var unregisterInstance = function unregisterInstance(instance, tz) {
  var instances = instancesForTz[tz].splice(instancesForTz[tz].indexOf(_this), 1);
  if (instances.length === 0) clearInterval(intervalHandleForTz[tz]);
};

function UsesToday(Component) {
  var UsesTodayComponent = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2.default)(UsesTodayComponent, _React$Component);

    function UsesTodayComponent(props) {
      var _this2;

      (0, _classCallCheck2.default)(this, UsesTodayComponent);
      _this2 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UsesTodayComponent).call(this, props));
      registerInstance((0, _assertThisInitialized2.default)(_this2), props.tz);
      return _this2;
    }

    (0, _createClass2.default)(UsesTodayComponent, [{
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var oldTz = this.props.tz;
        var newTz = nextProps.tz;

        if (newTz !== oldTz) {
          unregisterInstance(this, oldTz);
          registerInstance(this, newTz);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        unregisterInstance(this, this.props.tz);
      }
    }, {
      key: "render",
      value: function render() {
        var tz = this.props.tz;
        return _react.default.createElement(Component, Object.assign({
          today: todayForTz[tz]
        }, this.props));
      }
    }]);
    return UsesTodayComponent;
  }(_react.default.Component);

  (0, _utils.attachWrappedComponent)(UsesTodayComponent, Component);
  UsesTodayComponent.displayName = "UsesToday(" + (0, _getComponentName.default)(Component) + ")";
  UsesTodayComponent.propTypes = Object.assign({}, (0, _omit.default)(Component.propTypes, 'today'), {
    tz: _propTypes.default.oneOf(['userTz', 'portalTz', 'utc']).isRequired
  });
  UsesTodayComponent.defaultProps = Object.assign({}, (0, _omit.default)(Component.defaultProps, 'today'), {
    tz: 'userTz'
  });
  return UsesTodayComponent;
} // Export hook for test reset


UsesToday.instancesForTz = instancesForTz;
module.exports = exports.default;